export enum CommentsAction {
  creatingComment = 'creating-comment',
  creatingReply = 'creating-reply',
  editing = 'editing',
}
